import { AssignationStatus } from "@daytrip/legacy-enums";

import { AcceptanceRateInfo } from "../models/AcceptanceRateInfo";
import type { Assignation } from "../models/Assignation";

export function transformAssignationsToAcceptanceRateInfo(assignations: Array<Assignation>): AcceptanceRateInfo {
    const assignationsStats = { acceptedCount: 0, declinedCount: 0 };
    assignations.reduce((accumulator, a) => {
        if (a.status === AssignationStatus.Accepted) {
            accumulator.acceptedCount += 1;
        } else if (a.status === AssignationStatus.Declined) {
            accumulator.declinedCount += 1;
        }
        return accumulator;
    }, assignationsStats);

    // If driver is new and accepted/declined nothing - we cannot say that he is "zombie". Can we?
    const rate =
        assignationsStats.declinedCount || assignationsStats.acceptedCount
            ? assignationsStats.acceptedCount / (assignationsStats.acceptedCount + assignationsStats.declinedCount)
            : null;

    const acceptanceRateInfo = new AcceptanceRateInfo();
    acceptanceRateInfo.assignationsAccepted = assignationsStats.acceptedCount;
    acceptanceRateInfo.assignationsDeclined = assignationsStats.declinedCount;
    acceptanceRateInfo.rate = rate;

    return acceptanceRateInfo;
}
